import { useCallback, useEffect, useRef, useState } from 'react';

import type { WalletLoaded } from '@sorare/wallet-shared/src/contexts/messaging';
import { useMessagingContext } from 'contexts/wallet';
import { WalletTab, useWalletDrawerContext } from 'contexts/walletDrawer';

import { useOAuthEthWallet } from './useOAuthEthWallet';

export const useCreateAndLoadWallet = () => {
  const { needsCreateEthWallet } = useOAuthEthWallet();
  const { registerHandler } = useMessagingContext();
  const { closeWalletAndDrawer, showWallet, setCurrentTab } =
    useWalletDrawerContext();
  const [initialValueOfNeedsCreateEthWallet] = useState(needsCreateEthWallet);
  const resolveRef = useRef<() => void>(undefined);

  const promise = useCallback(async () => {
    return new Promise<void>(resolve => {
      if (!initialValueOfNeedsCreateEthWallet) {
        resolve();
      } else {
        resolveRef.current = resolve;
        showWallet();
        setCurrentTab(WalletTab.GENERATE_KEYS);
      }
    });
  }, [initialValueOfNeedsCreateEthWallet, setCurrentTab, showWallet]);

  useEffect(() => {
    registerHandler<WalletLoaded>('walletLoaded', async () => {
      closeWalletAndDrawer();
      resolveRef.current?.();
      return {};
    });
  }, [registerHandler, closeWalletAndDrawer]);

  return promise;
};
